import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';




const json = {
    1: { // Exercise num
        unit: 'Review 2',
        id: 'WB4-V2-PV2-P47-E1',
        audio: '',
        video: '',
        component: Circle_Write,
        exerciseKey: 'img/FriendsPlus/Page47/E1/Key/answerKey.png',
        // titleQuestion: [{ num: '1', title: 'Circle and. Then write two sentences for each sentence.', color: "#5B5A5D" }],
        question: {
            Write: {
                inputStyle: { width: 220 },
                answers: ['blanket', 'sky', 'star'],
                initialValue: [],
            },
            Circle: {
                initialWordStyle: { display: 'inline-block', borderRadius: '50%', color: 'transparent', width: 130, height: 105, fontSize: 0 },
                selectWordStyle: { border: 'solid 4px', borderColor: 'gray' },
                limitSelect: 1,
                listWords: [
                    '1934  1834 1734 ', //0 
                    '1934  1534 1434 ', //0 
                    '1334  1234 1134 ', //0 

                ],
                answers: ['0-0', '1-4', '2-0'],
                initialValue: [],
            },
            Layout: `
          <div style="width: 1000px; position:relative;">
            <img src="img/FriendsPlus/Page47/E1/1.jpg"/>
            <div style="display:flex; line-height:135px; position:absolute; top:213px; left:80px; word-spacing: 18px;"> 
                <div >
                    <div> <input id='0' type='Circle' /></div>
                    <div> <input id='1' type='Circle' /></div>
                    <div> <input id='2' type='Circle' /></div>
                </div>
                <div style="margin:-145px 0 0 97px">
                    <div><u style="color:gray;"> Cloud &ensp;</u></div>
                    <div><input id='0' /></div>
                    <div><input id='1' /></div>
                    <div><input id='2' /></div>
                </div>
            </div>
           
          </div>
          `,
        },
    },
    2: { // Exercise num
        unit: 'Review 2',
        id: 'WB4-V2-PV2-P47-E2',
        audio: '',
        video: '',
        component: D1,
        checkUppercase: true,
        exerciseKey: 'img/FriendsPlus/Page47/E2/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page47/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page47/E2/2.jpg' },
                { url: 'img/FriendsPlus/Page47/E2/3.jpg', input: true, answer: "Yes, he does." },
                { url: 'img/FriendsPlus/Page47/E2/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page47/E2/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page47/E2/6.jpg' },
                { url: 'img/FriendsPlus/Page47/E2/7.jpg', input: true, answer: "No, he doesn't." },
                { url: 'img/FriendsPlus/Page47/E2/8.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page47/E2/9.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page47/E2/10.jpg' },
                { url: 'img/FriendsPlus/Page47/E2/11.jpg', input: true, answer: "Yes, He does." },
                { url: 'img/FriendsPlus/Page47/E2/12.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page47/E2/13.jpg' },
            ],

        ],
    },

}

export default json;